import {
  BatteryIcon,
  BluetoothIcon,
  HeritageRingOutlineIcon,
  ReadinessIcon,
  UnionIcon,
  WaterDropIcon,
} from '@jouzen/ecom-components';

import type { PopTechSpecsFeatureData } from '@/app/[locale]/product/rings/_types';

export const popTechSpecsFeatures: PopTechSpecsFeatureData[] = [
  {
    copy: 'pop_tech_specs_materials_copy',
    Icon: ReadinessIcon,
    id: 'materials',
    title: 'pop_tech_specs_materials_title',
  },
  {
    copy: 'pop_tech_specs_battery_copy',
    Icon: BatteryIcon,
    id: 'battery',
    title: 'pop_tech_specs_battery_title',
  },
  {
    copy: 'pop_tech_specs_water_resistant_copy',
    Icon: WaterDropIcon,
    id: 'water_resistant',
    title: 'pop_tech_specs_water_resistant_title',
  },
  {
    copy: 'pop_tech_specs_dimensions_copy',
    Icon: HeritageRingOutlineIcon,
    id: 'dimensions',
    title: 'pop_tech_specs_dimensions_title',
  },
  {
    copy: 'pop_tech_specs_compatibility_copy',
    Icon: UnionIcon,
    id: 'compatibility',
    title: 'pop_tech_specs_compatibility_title',
  },
  {
    copy: 'pop_tech_specs_connectivity_copy',
    Icon: BluetoothIcon,
    id: 'connectivity',
    title: 'pop_tech_specs_connectivity_title',
  },
];
